import { isMockMode, post, simulateDelay } from "../api";

export const deleteUpdateInstaller = (data, isDelete = false) => {
	data.isDeleted = isDelete;

	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(1000, () => testData);
	}

	return post(`Products/UpdateInstaller`, data, {
		successMessage:
			isDelete === true
				? "Installer successfully deleted"
				: isDelete === false
				? "Installer successfully created"
				: null,
	});
};
